import React from 'react';
import Section, { SectionHeader } from 'components/PathBuilder/Sidebar/Section';
import Text, { TEXT_VARIANTS } from 'components/ui/Typography/Text';
import { Icon } from 'ui';
import { routes } from 'constants/config';

const ConfirmationEmails = args => {
  return (
    <Section>
      <SectionHeader className="d-f jc-sb">
        <span>Event Attendance Report</span>
      </SectionHeader>
      <Text variant={TEXT_VARIANTS.BODY_LIGHT} className="mb-4">
        <a
          href={routes.INSIGHTS.IN_PERSON_TRAINING.EVENT_REPORT(args.eventId)}
          className="DataCard-link"
        >
          <Icon name="download" /> {t('common.download_report')}
        </a>
      </Text>
    </Section>
  );
};

export default ConfirmationEmails;
